import { createStore } from 'zustand'
import { parseAuthForm } from '@/scopes/auth/domain/authForm'
import { AuthState, AuthStore } from '@/scopes/auth/domain/types'

export function createInitialAuthState(search: string): AuthState {
  return {
    activeForm: parseAuthForm(search),
    submitStatus: 'idle',
    submitError: null,
    pageInitializationStatus: 'idle',
  }
}

export function createAuthStore(initialState: AuthState = createInitialAuthState('')) {
  return createStore<AuthStore>(set => ({
    ...initialState,
    setIn: (key, value) => {
      set(state => ({ ...state, [key]: value }))
    },
  }))
}
